import Paragraph from "@vfuk/core-paragraph";
import QRCode from "qrcode.react";
import { useTranslation } from "react-i18next";
import { FloatingLabelInput } from "@ucchub/ui";

interface SetupMFAFormProps {
  QRCodeValue: string;
  twoFactor: string;
  onTwoFactor: (twoFactor: string) => void;
}

const SetupMFAForm = ({
  QRCodeValue,
  twoFactor,
  onTwoFactor,
}: SetupMFAFormProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <Paragraph justify="center">{t("core:auth:mfa_header")}</Paragraph>
      <Paragraph justify="center">
        <QRCode value={QRCodeValue} size={150} />
      </Paragraph>
      <Paragraph justify="center">{t("core:auth:mfa_footer")}</Paragraph>
      <br />
      <FloatingLabelInput
        label={t("core:auth:mfa_securitycode")}
        type="password"
        value={twoFactor}
        id="password"
        onChange={(e) => onTwoFactor(e.target.value)}
      />
    </div>
  );
};

export default SetupMFAForm;
